import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "no-scheme-med-freq" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }


export default /*#__PURE__*/_defineComponent({
  __name: 'NoSchemeMedicationFrequency',
  props: {
    value: { default: undefined },
    disabled: { type: Boolean, default: false }
  },
  emits: ["fix-period-click"],
  setup(__props: any, { emit }: { emit: ({(e: 'fix-period-click'): void}), expose: any, slots: any, attrs: any }) {





const onFixClick = () => {
    emit('fix-period-click');
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (!__props.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(" Период выдачи не указан. "),
          (!__props.disabled)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                class: "fix-freq-btn",
                onClick: onFixClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Исправить ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, " Период выдачи: сразу "))
  ]))
}
}

})